var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('img',{attrs:{"alt":"404 error","src":require('@/assets/images/errorPage.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }